<template>
  <div>

    <div class="row">
      <div class="col-3">
        <div class="listy">
          <span class="label">
            Template
          </span>
          <templateSelector @clear="deleteTemplate" @selected="setTemplate" :type="2" />
        </div>
      </div>
      <div class="col-3">

      </div>
      <div class="col-3">
        <div class="listy">
          <span class="label">
            User
          </span>
          <userAutoComplete :place="t.search_user" v-on:selected="setUser" />
          <p v-if="selectedUser">
            <a href="#">{{ selectedUser.username }}</a>
          </p>
        </div>
      </div>
    </div>

    <div class="alert alert-success" v-if="saved">All limits are updated successfully.</div>
    <loading :active.sync="isLoading"></loading>

      <table class="table table-bordered table-lg table-v2 table-striped mt-3">
        <thead>
        <tr>
          <th>
            <select class="choicesx form-control form-control-sm form-control-faded" v-model="sport">
              <option :value="sport.id" v-for="sport in sports">{{ sport.name }}</option>
            </select>
          </th>
          <th class="w100">
            <div class="text-left">
              <autocomplete v-if="regions"
                @selected="setRegion"
                @clear="deleteRegion"
                :source="Object.values(regions)">
              </autocomplete>
            </div>
          </th>
          <th>
            <div class="text-left w120">
              <autocomplete v-if="regions"
                @selected="setCompetition"
                @clear="deleteCompetition"
                :source="Object.values(competitions)">
              </autocomplete>
            </div>
          </th>
          <th>
            <select class="w120 form-control form-control-sm form-control-faded"  v-model="type">
              <option :value="t.value" v-for="t in types">{{ t.n }}</option>
            </select>
          </th>
        </tr>
        <tr>
          <th>Sport</th>
          <th class="text-left">Market</th>
          <th>% Percent of Max Stake</th>
          <th >% Percent of Max Earnings</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>

          </td>
          <td>

          </td>
          <td class="w120">
            <autocomplete
              @selected="setCurrency"
              resultsDisplay="iso_code"
              :source="currencies">
            </autocomplete>
          </td>
          <td>
            <a class="w120 btn btn-block btn-outline-info" v-on:click="setMarkets">
              {{ t.save }}
            </a>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            General
            <a href="javascript:;" @click="lockAllMarkets" class="btn pull-right" :class="(locked) ? 'btn-primary' : 'btn-outline-primary'">
              <i class="icon-lock" :class="(locked) ? 'icon-lock' : 'icon-lock-open'"></i>
            </a>
          </td>
          <td>
            <div class="text-center">
              <label for="volume" class="pull-left text-danger">%0</label>
              <label for="" class="pull-right text-success">%100</label>
              <div class="text-primary">%{{ generalStakePercent }}</div>
              {{ stakeLimits[currency] | percentageOfNumber(generalStakePercent) }}
            </div>
            <input type="range" id="volume" name="volume" v-model="generalStakePercent"
                   min="0" max="100" step="0.25">
          </td>
          <td>
            <div class="text-center">
              <label for="volume" class="pull-left text-danger">%0</label>
              <label for="" class="pull-right text-success">%100</label>
              <div class="text-primary">%{{ generalPrizePercent }}</div>
              {{ prizeLimits[currency] | percentageOfNumber(generalPrizePercent) }}
            </div>
            <input type="range" id="volume" name="volume" v-model="generalPrizePercent"
                   min="0" max="100" step="0.25">
          </td>
        </tr>
        <tr v-for="market in markets">
          <td class="text-left" width="100">{{market.sport}}</td>
          <td class="text-left" width="200">
           <router-link :to="{query: {marketId: market.id}}">
             {{market.name}}
           </router-link>
            <a href="javascript:;" @click="setMarketLock(market)" class="btn pull-right" :class="(market.locked) ? 'btn-primary' : 'btn-outline-primary'">
              <i class="icon-lock" :class="(market.locked) ? 'icon-lock' : 'icon-lock-open'"></i>
            </a>
          </td>
          <td width="200">
            <div class="text-center">
              <label for="volume" class="pull-left text-danger">%0</label>
              <label for="" class="pull-right text-success">%100</label>
              <div class="text-primary">%{{ market.limit }}</div>
              {{ stakeLimits[currency] | percentageOfNumber(market.limit) }}
            </div>
            <input type="range" id="volume" name="volume" v-model="market.limit"
                   min="0" max="100" step="0.25">
          </td>
          <td width="200">
            <div class="text-center">
              <label for="volume" class="pull-left text-danger">%0</label>
              <label for="" class="pull-right text-success">%100</label>
              <div class="text-primary">%{{ market.prizeLimit }}</div>
              {{ prizeLimits[currency] | percentageOfNumber(market.prizeLimit) }}
            </div>
            <input type="range" id="volume" name="volume" v-model="market.prizeLimit"
                   min="0" max="100" step="0.25">
          </td>
        </tr>
        <tr>
          <td colspan="10">
            <a class="btn btn-block btn-outline-info" v-on:click="setMarkets">
              {{ t.save }}
            </a>
          </td>
        </tr>
        </tbody>
      </table>

    <sweet-modal ref="umodal" v-on:close="closeSettingModal">
      <marketSettings :live="live" :id.sync="$route.query.marketId" v-if="$route.query.marketId > 0" />
    </sweet-modal>
  </div>
</template>

<script>
    import userAutoComplete from '@/components/autocomplete/userAutoComplete'
    import formatter from '@/mixins/formatter'
    import Autocomplete from 'vuejs-auto-complete'
    import templateSelector from '@/components/feed/element/templateSelector'
    import marketSettings from '@/components/user/bets/betMarketSettings'

    export default {
        name: 'betMarketLimitations',
        components: {marketSettings, Autocomplete, userAutoComplete, templateSelector},
        mixins: [formatter],
        props: {
            uid:{
                default: 0
            }
        },
        data () {
            return {
                selectedUser: null,
                template: 0,
                currencies: [],
                currency: 0,
                saved: false,
                isLoading: true,
                t: this.$root.t,
                type: '',
                types: [
                    {n: 'Pre', value: ''},
                    {n: 'Live', value: '1'},
                ],
                sport: 1,
                markets: [],
                sports: [],
                regions: [],
                region: 0,
                competition: 0,
                competitions: [],
                stakeLimits: [],
                generalStakeLimit: 1000,
                generalPrizeLimit: 1000,
                generalStakePercent: 100,
                generalPrizePercent: 100,
                locked: true
            }
        },
        watch: {
          '$route.query.marketId' () {
              this.$refs.umodal.open();
          },
          sport () {
              this.fetchMarkets()
              this.fetchRegions()
          },
          region () {
              this.fetchMarkets()
              this.fetchCompetitions()
          },
          uid () {
            this.fetchMarkets()
          },
          competition () {
              this.fetchMarkets()
          },
          type () {
              this.live = this.type;
              this.fetchMarkets()
          },
          template () {
              this.fetchMarkets()
          },
          generalStakePercent () {
              this.updateAllMarkets()
          },
          generalPrizePercent () {
            this.updateAllMarkets()
          }
        },
        mounted () {
            this.fetchSports()
            this.fetchMarkets()
            this.fetchRegions()
            this.fetchCompetitions()
        },
        methods: {
            updateAllMarkets() {
              var th = this;
              this.markets.forEach( (d) => {
                if(d.locked === true){
                  d.limit = th.generalStakePercent;
                  d.prizeLimit = th.generalPrizePercent;
                }
              })
            },
            lockAllMarkets () {
              var locked = (this.locked === true) ? false : true;
              this.locked = locked;
              var th = this;

              this.markets.forEach( (d) => {
                d.locked = th.locked;
              })
            },
            setMarketLock (m) {
              m.locked = (m.locked === true) ? false : true;
            },
            deleteTemplate () {
              this.template = 0;
            },
            setTemplate(d) {
              this.template = d.value;
            },
            setUser(uid) {
              this.uid = uid.id;
              this.selectedUser = uid;
            },
            setCurrency(c) {
              console.log(c);
              this.currency = c.value;
              this.generalStakePercent = this.stakeLimits[c.value];
              this.generalPrizePecent = this.prizeLimits[c.value];
            },
            setCompetition (c) {
              this.competition = c.value;
            },
            setRegion (r) {
              this.region = r.value;
            },
            deleteCompetition (c) {
              this.competition = 0;
            },
            deleteRegion (r) {
              this.region = 0;
            },
            fetchMarkets() {
                this.$http.get(api+'api/v1/market/limit/'+this.uid, {params: {template: this.template, sportId: this.sport, live: this.live, competition: this.competition}})
                    .then(response => {

                        this.isLoading = false;
                        this.markets = response.body.result.markets;
                        this.stakeLimits = response.body.stakeLimits;
                        this.prizeLimits = response.body.prizeLimits;
                        this.currencies = response.body.currencies;

                        if(this.currency == 0){
                          this.currency = response.body.currency;
                          this.generalStakePercent = this.stakeLimits[this.currency];
                          this.generalPrizePecent = this.prizeLimits[this.currency];
                        }

                    }, response => {

                    })
            },
            setMarkets() {

                this.saved = false;
                this.isLoading = true;
                this.$http.post(api+'api/v1/market/limit/'+this.uid+'?template='+this.template+'&sportId='+this.sport+'&live='+this.live+'&competition='+this.competition, {markets: this.markets})
                    .then(response => {

                        this.currencies = response.body.currencies;
                        this.stakeLimits = response.body.stakeLimits;
                        this.prizeLimits = response.body.prizeLimits;
                        this.isLoading = false;
                        this.saved = true;

                    }, response => {

                        this.saved = false;
                    })

            },
            fetchSports () {
                this.$http.get(api+'api/v1/fixture/sport?per_page=99999999').then(response => {
                    // get body data
                    this.sports = response.body.result.sport;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            fetchRegions () {
                this.$http.get(bsapi+'api/v1/fixture/region?per_page=99999999&sport='+this.sport).then(response => {
                    // get body data
                    this.regions = response.body.result.region;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            fetchCompetitions () {
                this.$http.get(bsapi+'api/v1/fixture/competition?per_page=99999999&sport[]='+this.sport+'&region[]='+this.region).then(response => {
                    // get body data
                    this.competitions = response.body.result.competition;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            },
            closeSettingModal (){
                this.$router.push({query: {}});
                setTimeout(() => {
                    document.body.style.overflow='auto';
                }, 500);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input[type=range] {
    display: block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/bets/betMarketLimitations.vue